import { forwardRef } from 'react';
import { Search, X } from 'lucide-react';
import { cn } from '@/lib/utils';

interface SearchFilterProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
}

export const SearchFilter = forwardRef<HTMLInputElement, SearchFilterProps>(function SearchFilter({
  value,
  onChange,
  placeholder = 'Search...',
  className,
}, ref) {
  return (
    <div className={cn('relative', className)}>
      <Search className={cn(
        'absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2',
        value ? 'text-primary' : 'text-muted-foreground'
      )} />
      <input
        ref={ref}
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className={cn(
          'h-10 w-full rounded-md bg-background pl-9 pr-9 text-sm placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2',
          value
            ? 'border border-primary bg-primary/5 font-medium'
            : 'border border-input'
        )}
      />
      {value && (
        <button
          type="button"
          onClick={() => onChange('')}
          className="absolute right-3 top-1/2 -translate-y-1/2 text-muted-foreground hover:text-foreground"
          aria-label="Clear search"
        >
          <X className="h-4 w-4" />
        </button>
      )}
    </div>
  );
});
